const support = `
### Contact

- Product questions and problems: [support@censuszen.com](mailto:support@censuszen.com). We reply within one business day, Monday to Friday, Central time.
- Plan, seats, and invoices: [billing@censuszen.com](mailto:billing@censuszen.com).
- A security or privacy concern, including suspected wrong access to patient data: [security@censuszen.com](mailto:security@censuszen.com).

Do not put patient information in email: no names, initials, dates of birth, or clinical details. Send the case link from your browser and we will look it up on our side.

### What to include

The case link, what you clicked, what you expected, and what happened instead. The exact wording of any message on screen helps. The Feedback button at the bottom of every page sends suggestions straight to us.

### Security and HIPAA

How we handle data is answered on the [FAQ](/faq) under Is CensusZen HIPAA compliant? and What happens to data when a case is archived or deleted? A business associate agreement and the security packet are available on request from [security@censuszen.com](mailto:security@censuszen.com).

### Billing

Facility admins see the plan, status, seats, and usage on the [Billing](/billing) page. Cases over the monthly allowance are billed at the end of the period and are never blocked.
`;

export default support;
